module.exports = __webpack_public_path__ + "img/shield-img.8ece6612.png";